import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterDevices',
    standalone: false
})
export class FilterDevicesPipe implements PipeTransform {

  transform(value: any[], ...args: string[]): any[] {
    if (!args[0]) return value;
    const filterValue = args[0].toUpperCase();
    return value.filter((item: any) =>
      String(item.serial).toUpperCase().includes(filterValue) ||
      (item.name && String(item.name).toUpperCase().includes(filterValue))
    );
  }
}
